module.exports = __webpack_public_path__ + "static/media/btn_android_ch.32f2a683.png";